import utils from 'utils'

class reimburseListCtrl {
    constructor($scope, logger, httpRequest, $state, sweetalert, initSortService) {
        const aMonth = utils.genPeriodByMonth()
        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {
                type: '',
                startTime: aMonth.start,
                endTime: aMonth.end,
                workStatus: '',
                expenseNo: '',
                orgId: 0,
                userName: '',
                departmentName: '',
            },
        }
        $scope.reset = function reset() {
            $scope.param.param = {
                type: '',
                startTime: aMonth.start,
                endTime: aMonth.end,
                workStatus: '',
                expenseNo: '',
                orgId: 0,
                userName: '',
                departmentName: '',
            }
        }
        // 字典字段
        httpRequest.get_dictByTypeArr(['expense_work_status']).then((res) => {
            $scope.dictionary = res.data.value
        })
        // 状态按钮滑过
        $scope.dropdown_rowhover_state = function (row, flag) {
            row.dropdowstatenhover = flag
        }
        // 查询报销类型
        $scope.reimburseType = []
        httpRequest.get_getIvatBxPzDTOList(false).then((res) => {
            const allType = res.data.value
            for (let i = 0; i < allType.length; i++) {
                const obj = {
                    enumName: allType[i].expenseName,
                    enumCode: allType[i].confId,
                }
                $scope.reimburseType.push(obj)
            }
        })
        // 初始化查询和表格控件实例
        $scope.customizedConfig = {
            version: 1.03,
            queryConfig: [{
                label: '报销类型',
                selected: true,
                default: true,
            }, {
                label: '日期',
                selected: true,
                default: true,
            }, {
                label: '状态',
                selected: true,
                default: true,
            }, {
                label: '报销单号',
                selected: true,
                default: true,
            }, {
                label: '部门',
                selected: false,
                default: false,

            }],
            table: [{
                label: '报销单号',
                selected: true,
                default: true,
            }, {
                label: '部门',
                selected: true,
                default: true,
            }, {
                label: '金额',
                selected: true,
                default: true,
            }, {
                label: '状态',
                selected: true,
                default: true,
            }, {
                label: '发票张数',
                selected: true,
                default: true,
            }, {
                label: '姓名',
                selected: true,
                default: true,
            }, {
                label: '日期',
                selected: true,
                default: true,
            }, {
                label: '报销类型',
                selected: true,
                default: true,
            }, {
                label: '报销事由',
                selected: false,
                default: false,
            }],
        }
        $scope.$on('$stateChangeStart', (e, toState) => {
            if (toState.name.indexOf('input/reimburseManage/reimbursement') == -1) {
                sessionStorage.removeItem('reimburseListParam')
            }
        })
        // 表格下拉框配置
        $scope.tableDropdownConfig = [{
            label: '提交',
            handler(item) {
                $scope.doSubmit([item.expenseId], false)
            },
            showWhile(item, hasPermit) {
                return hasPermit('reim_submit') && item.workStatus == 0
            },
        }, {
            label: '详情',
            handler(item) {
                $state.go('input.reimburseManage.reimbursement.detail', {
                    expenseId: item.expenseId,
                })
            },
            showWhile(item, hasPermit) {
                return hasPermit('reim_detail')
            },
        }, {
            label: '编辑',
            handler(item) {
                $state.go('input.reimburseManage.reimbursement.edit', {
                    expenseId: item.expenseId,
                })
            },
            showWhile(item, hasPermit) {
                return hasPermit('reim_edit') && (item.workStatus == 0 || item.workStatus == 2)
            },
        }, {
            label: '撤回',
            handler(item) {
                $scope.drawback(item.expenseId)
            },
            showWhile(item, hasPermit) {
                return hasPermit('reim_back') && item.workStatus == 1
            },
        }, {
            label: '删除',
            handler(item) {
                $scope.delReimburse(item.expenseId)
            },
            showWhile(item, hasPermit) {
                return hasPermit('remi_del') && item.workStatus == 0
            },
        }]

        // 批量提交
        $scope.batchSubmit = function batchSubmit() {
            if (!$scope.selectedRows.length) {
                logger.logError('请至少选择一张报销单据提交')
                return
            }
            const expenseIds = []
            let exitFlag = false
            $scope.selectedRows.forEach((item) => {
                if (item.workStatus == '1' || item.workStatus == '1') { // 非提交状态
                    exitFlag = true
                }
                expenseIds.push(item.expenseId)
            })
            if (!exitFlag) {
                $scope.doSubmit(expenseIds, true)
            } else {
                logger.logError('多选数据中存在“已审核”或“待审核”单据，请取消勾选后再提交！')
            }
        }
        $scope.doSubmit = function (reimArr, isBatch) {
            httpRequest.post_batchSubmitExpenses(reimArr).then((res) => {
                if (res.data.success) {
                    const msg = isBatch ? '批量提交成功' : '票据提交成功'
                    logger.logSuccess(msg)
                }
                $scope.queryTaxInfo()
            })
        }
        $scope.drawback = function (expenseId) {
            sweetalert.confirm('撤回提醒', '确认撤回此单据？').then(() => {
                httpRequest.get_withdrawExpense({
                    expenseId,
                }).then((res) => {
                    if (res.data.success) {
                        logger.logSuccess('撤回成功')
                        $scope.queryTaxInfo()
                    }
                })
            }, () => {})
        }
        // 删除多个确认弹窗
        $scope.delReimburse = function (id) {
            const msg = '确认删除此单据?'
            sweetalert.confirm('删除提醒', msg).then(() => {
                httpRequest.get_deleteExpenseItem({
                    expenseId: id,
                }).then((res) => {
                    $scope.queryTaxInfo()
                })
            }, () => {})
        }
        // 表头排序
        $scope.orderMap = initSortService('reimburseListParam')
        $scope.selectedHandle = function () {
            $scope.param.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem('reimburseListParam', JSON.stringify($scope.param))
            $scope.queryTaxInfo()
        }
        // 查询列表
        $scope.queryTaxInfo = function () {
            $scope.param = sessionStorage.reimburseListParam ? JSON.parse(sessionStorage.reimburseListParam) : $scope.param
            httpRequest.post_qryExpenseListOfPage($scope.param).then((res) => {
                $scope.listData = res.data.value.list
                // 获取后台分页数据 回写分页组件
                $scope.totalItems = res.data.value.total //
                $scope.param.pageNum = res.data.value.pageNum
                // 查询之后清空已经选择的数据
                $scope.selectedRows = []
            })
        }
        $scope.searchList = function () {
            sessionStorage.setItem('reimburseListParam', JSON.stringify($scope.param))
            $scope.queryTaxInfo()
        }
        $scope.queryTaxInfo()
        // 分页
        $scope.pageChanged = function () { // 点击页码发起查询
            sessionStorage.setItem('reimburseListParam', JSON.stringify({
                orderMap: $scope.param.orderMap,
                pageNum: $scope.param.pageNum,
                pageSize: $scope.param.pageSize,
                param: sessionStorage.reimburseListParam ? JSON.parse(sessionStorage.reimburseListParam).param : {
                    type: '',
                    startTime: aMonth.start,
                    endTime: aMonth.end,
                    workStatus: '',
                    expenseNo: '',
                    orgId: 0,
                    userName: '',
                    departmentName: '',
                },
            }))
            $scope.queryTaxInfo()
        }
        $scope.totalItems = 0 // 组件初始化设置总页数
        // $scope.queryTaxInfo()
    }
}

reimburseListCtrl.$inject = ['$scope', 'logger', 'httpRequest', '$state', 'sweetalert', 'initSortService']
export default reimburseListCtrl



// WEBPACK FOOTER //
// ./src/app/input/reimburseManage/reimbursement/reimburseListCtrl.js